import { type FC } from "react";

// TODO: Props は変数を受け取って渡す際に定義する。
export const DefaultHeader: FC = () => {
  return <div>{/* TODO:デザイン確定後要修正 */}</div>;
};
